import { useSelector } from "react-redux"
import { createCheckoutRequest } from "../../services/checkout"

export function DebugToolCartSnippet() {
    const cart: Cart = useSelector((state: AppState) => state.cart)
    const user: User = useSelector((state: AppState) => state.currentUser)
    
    function onShow() {
        const req = createCheckoutRequest(cart,user);
        return JSON.stringify(req, null, 1);
    }
    return (
        <div className="snippet-container">
            <pre>
                { onShow() }
            </pre>
        </div>
    )
}